export default __webpack_public_path__ + "static/media/rocket.9efa7574.png";